import './App.scss';
import 'bulma/css/bulma.css'
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import Header from './commonComponents/Header'
import Footer from './commonComponents/Footer'
import Home from "./AppComponents/Home"
import Games from "./AppComponents/Games"
import Game from "./AppComponents/Game"
import Subscribe from "./AppComponents/Subscribe"
import FreeGames from "./AppComponents/FreeGames"
import Mobile from "./AppComponents/Mobile"
import OTP from "./AppComponents/OTP"
import NotFound from "./AppComponents/NotFound"
import { useEffect, useState } from 'react';
import SideMenu from './AppComponents/SideMenu';
import ReactGA from 'react-ga';
import queryString from "query-string";
import _ from "lodash";
import { reactLocalStorage } from 'reactjs-localstorage';
import config from "./config"
import Category from './commonComponents/Category';
import Profile from "./AppComponents/Profile";
import Unsubscribe from './AppComponents/Unsubscribe';
function App() {
      const [sideMenu, setSideMenu] = useState(false)
      const [showSideMenu, setshowSideMenu] = useState(true)
      const [allGames, setAllGames] = useState([])
      const [loading , setLoading] = useState(true)
      const [banners,setBanners]=useState([])
      const [games,setGames]=useState([])
      const [centerLogo,setCenterLogo]=useState(true)
      const [rightLogo,setRightLogo]=useState(false)
      const match1 = useRouteMatch('/game/:id')
      const match2 = useRouteMatch('/freegames')
      const [appConfigData, setappConfigData] = useState({})
      console.log(">>>route match:::", match1, match2)
      const history = useHistory();
       console.log("the current url is:::",window.location.href)
       let url=window.location.href;
        let name=url.split(".")[1]?url.split(".")[1]:null
        console.log("name :::",name)
      useEffect(() => {
            ReactGA.initialize('G-6HPV1TM4W4');
            // ReactGA.pageview(window.location.pathname+window.location.search)
            ReactGA.pageview(window.location.href);
            getAppConfigData()
      }, [])

      useEffect(() => {
            console.log("Analytics initialize")
            const ga_tag = config.get("ga_tag");
            const ga_debug = config.get("ga_debug");
            console.log("GOOGLE ANALYTICS DEBUG :: ", ga_tag, " :: ", ga_debug);
            ReactGA.initialize(ga_tag, {
              debug: ga_debug,
              titleCase: false,
            });
            // to report page view
            history.listen((location) => {
              ReactGA.set({ page: location.pathname });
              ReactGA.pageview(location.pathname);
            });
          }, []);

      const getAppConfigData = () => {
            const url = `${config.get('base')}${config.get('appConfig')}`
            fetch(url, {
                  method: 'POST',
                  body: JSON.stringify({ "mcc": "652", "mnc": "04" ,"uid" : reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : ""}),
                  // headers: {...config.get('headers'),'Servicefor':name}
                  headers:config.get('headers')
            })
                  .then(res => {
                        if (!res.ok) { throw res }
                        return res.json()
                  })
                  .then((result) => {
                        console.log('result message appConfig ::', result)
                        const appConfigObj = {
                              menu: result.menu,
                              menu_color: result.menu_color,
                              home_logo: result.home_logo,
                              menu_logo: result.menu_logo,
                              view_all:result.view_all,
                              bg_color:result.bkg_color,
                              play_text:result.play_btn_txt,
                              flow:result.subRedirectFlow,
                              view_btn_txt:result.view_btn_txt,
                              sub_url:result.sub_url,
                              unsub_mode:result.unsubMode,
                        }
                        setappConfigData(appConfigObj)
                        setLoading(false)
                        setGames(result.games_list)
                        setBanners(result.banner)
                        reactLocalStorage.set("unsub_ok_txt",result.unsub_ok_txt)
                        reactLocalStorage.set("unsub_msg_txt",result.unsub_msg_txt)
                  }, 
                        (error) => {
                              console.log('error:::', error)
                        })
      }



      return (
            // <section className="hero is-fullheight bg"  style={{background:appConfigData.bg_color}}>
            <section className="hero is-fullheight bg" style={{padding:"0px"}}>
                  {!(match1 || match2) &&  <Header loading={loading} menuBar = {appConfigData.menu} 
                  sub_url={appConfigData.sub_url}
                  menuLogo={appConfigData.menu_logo} homeLogo={appConfigData.home_logo} handleClick={() => setSideMenu(!sideMenu)} showSideMenu={showSideMenu} 
                   centerLogo={centerLogo} rightLogo={rightLogo} setshowSideMenu={()=>setshowSideMenu(!showSideMenu)}  />}
                  <SideMenu menuColor= {appConfigData.menu_color} menuLogo={appConfigData.menu_logo} sideMenu={sideMenu} handleClose={() => setSideMenu(!sideMenu)} />
                  <Switch>
                        <Route path="/home">
                        <Home games={games}  banners={banners} bgColor={appConfigData.bg_color} view_all={appConfigData.view_all} 
                        
                         flow={appConfigData.flow}
                         view_btn_txt={appConfigData.view_btn_txt}/>
                        </Route>
                        <Route exact path="/">
                        <Home games={games}  banners={banners} bgColor={appConfigData.bg_color} view_all={appConfigData.view_all} flow={appConfigData.flow}
                         
                         view_btn_txt={appConfigData.view_btn_txt}/>
                        </Route>
                        <Route exact path="/subscribe">
                              <Subscribe />
                        </Route>
                        <Route path="/games">
                              <Games allGames = {allGames}/>
                        </Route>
                        <Route path="/game/:title/:id">
                              <Game view_all={appConfigData.view_btn_txt}/>
                        </Route>
                        <Route path="/freegames">
                              <FreeGames />
                        </Route>
                        <Route path="/profile">
                            <Profile/>
                        </Route>
                        <Route path="/login">
                              <Mobile setshowSideMenu={() => { setshowSideMenu(false) }} />
                        </Route>
                        <Route path="/otp">
                              <OTP setshowSideMenu={() => { setshowSideMenu(false) }} />
                        </Route>
                        <Route path="/category">
                             <Category play={appConfigData.play_text} 
                              />
                        </Route>
                        <Route path="/unsub">

                            <Unsubscribe unsub_mode={appConfigData.unsub_mode}/>
                        </Route>
                        <Route path="*">
                              <NotFound />
                        </Route>
                        
                  </Switch>
                  <Footer />
            </section>
      );
}
export default App
